import { Select, Statistic } from "antd";
import { formatMinutes, COUNTRY_CONFIG } from "../utils";
import { SummaryReportDTO } from "../types";

export type GroupBy = "project" | "user";

interface StatsBarProps {
  data: SummaryReportDTO | null;
  groupBy: GroupBy;
  onGroupByChange: (value: GroupBy) => void;
  workingDaysRo: number;
  workingDaysGe: number;
}

const StatsBar = ({
  data,
  groupBy,
  onGroupByChange,
  workingDaysRo,
  workingDaysGe,
}: StatsBarProps) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: 16,
      marginTop: 8,
    }}
  >
    <div style={{ display: "flex", gap: 32 }}>
      <Statistic
        title="Total Hours"
        value={formatMinutes(data?.totalDurationMinutes ?? 0)}
      />
      <Statistic title="Total Entries" value={data?.totalEntries ?? 0} />
      <Statistic
        title={`${COUNTRY_CONFIG.RO.label} Working Days`}
        value={workingDaysRo}
        valueStyle={{ color: COUNTRY_CONFIG.RO.color }}
      />
      <Statistic
        title={`${COUNTRY_CONFIG.GE.label} Working Days`}
        value={workingDaysGe}
        valueStyle={{ color: COUNTRY_CONFIG.GE.color }}
      />
    </div>
    <Select
      value={groupBy}
      onChange={onGroupByChange}
      style={{ width: 130 }}
      options={[
        { label: "Project", value: "project" },
        { label: "User", value: "user" },
      ]}
    />
  </div>
);

export default StatsBar;
